import { coreInitiativesLinksGetAsyncSlice } from './get';
import { CoreInitiativesLinksName } from './name';
import { createAddCollectionSyncSlice } from '@sonar-software/xuder';
import { InitiativeLink } from '@types';

export const coreInitiativesLinksAddSyncSlice = createAddCollectionSyncSlice({
	add: (file: InitiativeLink) => file,
	hasRequest: true,
	name: CoreInitiativesLinksName,
	state: coreInitiativesLinksGetAsyncSlice.asyncState
});
